"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Text", {
  enumerable: true,
  get: function get() {
    return _base.default;
  }
});
var _base = _interopRequireDefault(require("./base"));
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');